import Swal from 'sweetalert2';

/**
 * Show a SweetAlert2 confirmation dialog.
 * @param {string} title - Dialog title
 * @param {string} text - Dialog message
 * @param {object} options - Override defaults (icon, confirmButtonText, etc.)
 * @returns {Promise<boolean>} - true if confirmed
 */
export async function confirmAction(title, text, options = {}) {
  const result = await Swal.fire({
    title,
    text,
    icon: options.icon || 'warning',
    showCancelButton: true,
    confirmButtonColor: options.confirmColor || '#c62828',
    cancelButtonColor: '#616161',
    confirmButtonText: options.confirmText || 'Yes, proceed',
    cancelButtonText: options.cancelText || 'Cancel',
    reverseButtons: true,
    ...options,
  });
  return result.isConfirmed;
}

/**
 * Shorthand for delete confirmations.
 */
export async function confirmDelete(entityName) {
  return confirmAction(
    'Delete ' + entityName + '?',
    'This action cannot be undone.',
    { confirmText: 'Yes, delete', icon: 'warning' }
  );
}
